module.exports = __webpack_public_path__ + "img/layers-icon.3c3910c9.svg";